export const usuarioLogueado = () => {
  try {
    const raw = localStorage.getItem('usuarioLogueado');
    return raw ? JSON.parse(raw) : null;   // null cuando no hay sesión
  } catch {
    return null;
  }
};

// ✅ Escritura NORMALIZADA: garantizamos las claves que usa el front/Apollo
export const setLoguedInfo = (data) => {
  // Normaliza por si vienen en PascalCase o camelCase
  const normalized = {
    idToken: data.idToken || data.IdToken || null,
    accessToken: data.accessToken || data.AccessToken || null,
    refreshToken: data.refreshToken || data.RefreshToken || null,

    idLogin: data.idLogin ?? data.IdLogin ?? null,
    nombre: data.nombre ?? data.Nombre ?? '',
    nombreUsuario: data.nombreUsuario ?? data.NombreUsuario ?? '',
    correo: data.correo ?? data.Correo ?? '',
    rol: data.rol ?? data.Rol ?? '',
    razonSocial: data.razonSocial ?? data.RazonSocial ?? '',
    foto: data.foto ?? data.Foto ?? '',
  };

  // Guarda en la clave que tu authLink consume
  localStorage.setItem('usuarioLogueado', JSON.stringify(normalized));

  // (Opcional) Mantén compatibilidad con código legado que lea DASA_AUTH_JWT_ID
  if (normalized.idToken) {
    localStorage.setItem('DASA_AUTH_JWT_ID', normalized.idToken);
  } else {
    localStorage.removeItem('DASA_AUTH_JWT_ID');
  }
};

// ✅ Bandera simple para guards
export const isAuthenticated = () => {
  const u = usuarioLogueado();
  return !!(u && (u.idToken || u.accessToken));
};

// ✅ Logout consistente con lo que guardamos
export const logout = () => {
  localStorage.removeItem('usuarioLogueado');
  localStorage.removeItem('DASA_AUTH_JWT_ID');
};